const extend = (from, to) => Object.assign({}, from, to);

export default extend;
